var _defs, _clipPath, _g, _defs2, _clipPath2, _g2, _defs3, _clipPath3, _g3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__a",
    d: "M-391.775-1386.928l12.825-12-12.825-12-1.575 1.425 11.25 10.575-11.25 10.575z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-chevronRight_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__c",
    d: "M-708.35-1719.928h1440v3464h-1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-398.35-1415.928h24.4v34h-24.4z",
    clipPath: "url(#icon-chevronRight_svg__d)"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__e",
    d: "M-391.775-1386.928l12.825-12-12.825-12-1.575 1.425 11.25 10.575-11.25 10.575z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-chevronRight_svg__f)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__g",
    d: "M-708.35-1719.928h1440v3464h-1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-398.35-1415.928h24.4v34h-24.4z",
    clipPath: "url(#icon-chevronRight_svg__h)"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__i",
    d: "M-385.554-1380.438l12.825-12-12.825-12-1.575 1.425 11.25 10.575-11.25 10.575z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__i"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-chevronRight_svg__j)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-chevronRight_svg__k",
    d: "M-702.129-1713.438h1440v3464h-1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-chevronRight_svg__l"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#icon-chevronRight_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-392.129-1409.438h24.4v34h-24.4z",
    clipPath: "url(#icon-chevronRight_svg__l)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.799 1.425L6.374 0l12.827 12L6.374 24l-1.575-1.425L16.051 12 4.799 1.425z"
  })));
}

export default SvgIconChevronRight;